var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 41",
    style: {
      enableBackground: "new 0 0 102 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;stroke:#C5C4C4;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st2{fill:#C5C4C4;}\r\n\t.st3{fill:#616160;}\r\n\t.st4{fill:#C4C4C4;}\r\n\t.st5{enable-background:new    ;}\r\n\t.st6{fill:#020203;}\r\n\t.st7{fill:none;stroke:#D3D3D3;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st8{fill:#D3D3D3;}\r\n\t.st9{fill:none;stroke:#C5C4C4;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#616160;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#616160;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st13{fill:#616160;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st15{fill:#1D70B8;}\r\n\t.st16{fill:#FFFFFF;stroke:#C5C4C4;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st17{fill:none;stroke:#616160;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st18{fill:none;stroke:#D3D3D3;stroke-width:0.5;}\r\n\t.st19{fill:#FFFFFF;stroke:#616160;}\r\n\t.st20{fill:none;stroke:#616160;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st21{fill:#FFFFFF;stroke:#616160;stroke-width:1.5;}\r\n\t.st22{fill:#C5C4C4;stroke:#C5C4C4;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st23{opacity:0.6;}\r\n\t.st24{opacity:0.6;fill:#C5C4C4;}\r\n\t.st25{fill:#FFFFFF;stroke:#616160;stroke-width:0.5;}\r\n\t.st26{fill:none;stroke:#616160;stroke-width:0.5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.2304,27h-13c-3.5898,0-6.5-2.9101-6.5-6.5v0c0-3.5898,2.9101-6.5,6.5-6.5h13c3.5898,0,6.5,2.9101,6.5,6.5 v0C39.7304,24.0899,36.8202,27,33.2304,27z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32.9326,
    cy: 20.5,
    r: 5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.7696,27h13c3.5898,0,6.5-2.9101,6.5-6.5v0c0-3.5898-2.9101-6.5-6.5-6.5h-13c-3.5898,0-6.5,2.9101-6.5,6.5 v0C62.2696,24.0899,65.1798,27,68.7696,27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 69.0674,
    cy: 20.5,
    r: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "19.7285,23.6313 16.9502,20.8535 17.6572,20.1465 19.7285,22.2173 24.2236,17.7222 24.9307,18.4292  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80.0958,
    y: 16.2574,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 9.1102 62.9941)",
    className: "st0",
    width: 0.9999,
    height: 8.4853
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 76.3531,
    y: 20.0001,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 9.1102 62.9941)",
    className: "st0",
    width: 8.4853,
    height: 0.9999
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle2);
export default __webpack_public_path__ + "static/media/Toggle2.c62b366679ceb621021822c4da54023a.svg";
export { ForwardRef as ReactComponent };